import {
  enableCollectionTimesEdit,
  setSelectedDepot,
  setSelectedPostcodes,
  setAreaRouteEditAction,
} from "./thunkActions";

import { DEFAULT_TIMEBAND } from "../../consts/strings";
import { createSlice } from "@reduxjs/toolkit";
import { defaultSnackbarOptions } from "../../utils/snackbar";

const initialState = {
  selectedDepot: null,
  selectedTimeBand: DEFAULT_TIMEBAND,
  selectedTab: null,
  previousSelectedTimeBand: null,
  selectedRoute: null,
  selectedDriver: null,
  selectedLocation: null,
  selectedSection: null,
  selectedShiftManager: null,
  editMapModalOpen: false,
  addArtificialPostcodeModalOpen: false,
  addDriverModalOpen: false,
  addSectionModalOpen: false,
  addRouteModalOpen: false,
  selectPlanModalOpen: false,
  unlockPlanModalOpen: false,
  unlockDepotModalOpen: false,
  unlockMatrixWeekModalOpen: false,
  unlockDriversWeekModalOpen: false,
  unlockDriversDayModalOpen: false,
  routeEditOptionsModalOpen: false,
  routeEditOptionsModalMessage: "",
  routeEditOptionsModalOptions: [],
  pickupEditOptionsModalOpen: false,
  pickupEditOptionsModalOptions: [],
  createNewTemplateModalOpen: false,
  createDatedPlanModalOpen: false,
  showReloadPlanManagement: false,
  showReloadDriverManagement: false,
  planManagementReloadModalOpen: false,
  driverManagementReloadModalOpen: false,
  driverManagementExpiredModalOpen: false,
  planManagementExpiredModalOpen: false,
  copyModalOpen: false,
  driversLockedError: null,
  depotLockedError: null,
  editPlanModalOpen: false,
  notifications: [],
  determinateLoading: null,
  showOptimiseAll: true,
  collectionTimeEdit: false,
  collectionEditPostcode: null,
  markerViewType: "D",
  loading: false,
  editOverridesModalOpen: false,
  editPickupModalOpen: false,
  selectedPostcodes: [],
  selectSimulatedOverlayOpen: false,
  selectedOverlaySimulationPercentage: 0,
  postcodeInUseModalContent: null,
};

export const ownAppSlice = createSlice({
  name: "ownApp",
  initialState,
  reducers: {
    resetAppState: () => initialState,
    setSelectedTimeBand: (state, action) => {
      if (state.selectedTimeBand !== action.payload)
        state.previousSelectedTimeBand = state.selectedTimeBand;
      state.selectedTimeBand = action.payload;
    },
    setSelectedRoute: (state, action) => {
      state.selectedRoute = action.payload;
    },
    setSelectedDriver: (state, action) => {
      state.selectedDriver = action.payload;
    },
    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
    setSelectedSection: (state, action) => {
      state.selectedSection = action.payload;
    },
    setSelectedShiftManager: (state, action) => {
      state.selectedShiftManager = action.payload;
    },
    setCollectionEditPostcode: (state, action) => {
      state.collectionEditPostcode = action.payload;
    },
    setEditMapModalOpen: (state, action) => {
      state.editMapModalOpen = action.payload;
    },
    setAddDriverModalOpen: (state, action) => {
      state.addDriverModalOpen = action.payload;
    },
    setAddSectionModalOpen: (state, action) => {
      state.addSectionModalOpen = action.payload;
    },
    setAddRouteModalOpen: (state, action) => {
      state.addRouteModalOpen = action.payload;
    },
    setAddArtificialPostcodeModalOpen: (state, action) => {
      state.addArtificialPostcodeModalOpen = action.payload;
    },
    setSelectPlanModalOpen: (state, action) => {
      state.selectPlanModalOpen = action.payload;
    },
    setUnlockDepotModalOpen: (state, action) => {
      state.unlockDepotModalOpen = action.payload;
    },
    setUnlockPlanModalOpen: (state, action) => {
      state.unlockPlanModalOpen = action.payload;
    },
    setUnlockDriversWeekModalOpen: (state, action) => {
      state.unlockDriversWeekModalOpen = action.payload;
    },
    setUnlockMatrixWeekModalOpen: (state, action) => {
      state.unlockMatrixWeekModalOpen = action.payload;
    },
    setUnlockDriversDayModalOpen: (state, action) => {
      state.unlockDriversDayModalOpen = action.payload;
    },
    setShowReloadPlanManagement: (state, action) => {
      state.showReloadPlanManagement = action.payload;
    },
    setShowReloadDriverManagement: (state, action) => {
      state.showReloadDriverManagement = action.payload;
    },
    setPlanManagementReloadModalOpen: (state, action) => {
      state.planManagementReloadModalOpen = action.payload;
    },
    setDriverManagementReloadModalOpen: (state, action) => {
      state.driverManagementReloadModalOpen = action.payload;
    },
    setDriverManagementExpiredModalOpen: (state, action) => {
      state.driverManagementExpiredModalOpen = action.payload;
    },
    setPlanManagementExpiredModalOpen: (state, action) => {
      state.planManagementExpiredModalOpen = action.payload;
    },
    setRouteEditOptionsModal: (state, action) => {
      state.routeEditOptionsModalOpen = action.payload.open;
      state.routeEditOptionsModalMessage = action.payload.message || "";
      state.routeEditOptionsModalOptions = action.payload.options || [];
    },
    setPickupEditOptionsModal: (state, action) => {
      state.pickupEditOptionsModalOpen = action.payload.open;
      state.pickupEditOptionsModalOptions = action.payload.options || [];
    },
    setCreateNewTemplateModalOpen: (state, action) => {
      state.createNewTemplateModalOpen = action.payload;
    },
    setCreateDatedPlanModalOpen: (state, action) => {
      state.createDatedPlanModalOpen = action.payload;
    },
    setCopyModalOpen: (state, action) => {
      state.copyModalOpen = action.payload;
    },
    setDriversLockedError: (state, action) => {
      state.driversLockedError = action.payload;
    },
    setDepotLockedError: (state, action) => {
      state.depotLockedError = action.payload;
    },
    setEditPlanModalOpen: (state, action) => {
      state.editPlanModalOpen = action.payload;
    },
    setSelectSimulatedOverlayOpen: (state, action) => {
      state.selectSimulatedOverlayOpen = action.payload;
    },
    setSelectedSimulationPercentage: (state, action) => {
      state.selectedOverlaySimulationPercentage = action.payload;
    },
    addNotification: (state, action) => {
      const { options, ...rest } = action.payload;
      state.notifications = [
        ...state.notifications,
        {
          ...rest,
          options: {
            ...defaultSnackbarOptions,
            ...options,
            key: new Date().getTime(),
          },
        },
      ];
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.options.key !== action.payload
      );
    },
    closeNotification: (state, action) => {
      state.notifications = state.notifications.map((notification) =>
        notification.options.key === action.payload
          ? { ...notification, dismissed: true }
          : { ...notification }
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDeterminateLoading: (state, action) => {
      state.determinateLoading = {
        maxValue: action.payload,
        currentValue: 0,
        normalisedValue: 0,
      };
    },
    increaseDeterminateLoading: (state) => {
      const newValue = state.determinateLoading.currentValue + 1;
      state.determinateLoading = {
        ...state.determinateLoading,
        currentValue: newValue,
        normalisedValue: (newValue * 100) / state.determinateLoading.maxValue,
      };
    },
    resetDeterminateLoading: (state) => {
      state.determinateLoading = null;
    },
    setShowOptimiseAll: (state, action) => {
      state.showOptimiseAll = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setCollectionTimeEdit: (state, action) => {
      state.collectionTimeEdit = action.payload;
    },
    setMarkerViewType: (state, action) => {
      state.markerViewType = action.payload;
    },
    setEditOverridesModalOpen: (state, action) => {
      state.editOverridesModalOpen = action.payload;
    },
    setEditPickupModalOpen: (state, action) => {
      state.editPickupModalOpen = action.payload;
    },
    resetSelectedPostcodes: (state) => {
      state.selectedPostcodes = [];
    },
    setPostcodeInUseModalContent: (state, action) => {
      state.postcodeInUseModalContent = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setSelectedDepot.pending, (state) => {
        state.selectedRoute = null;
        state.selectedDriver = null;
        state.selectedSection = null;
      })
      .addCase(setSelectedDepot.fulfilled, (state, action) => {
        state.selectedDepot = action.payload;
      })
      .addCase(setAreaRouteEditAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(setAreaRouteEditAction.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setAreaRouteEditAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(enableCollectionTimesEdit.pending, (state) => {
        state.loading = true;
      })
      .addCase(enableCollectionTimesEdit.rejected, (state) => {
        state.loading = false;
      })
      .addCase(enableCollectionTimesEdit.fulfilled, (state) => {
        state.loading = false;
        state.collectionTimeEdit = true;
      })
      .addCase(setSelectedPostcodes.fulfilled, (state, action) => {
        state.selectedPostcodes = action.payload;
      });
  },
});

const { reducer } = ownAppSlice;
const {
  resetAppState,
  setSelectedTimeBand,
  setSelectedRoute,
  setSelectedDriver,
  setSelectedLocation,
  setSelectedSection,
  setSelectedShiftManager,
  setCollectionEditPostcode,
  setEditMapModalOpen,
  setAddArtificialPostcodeModalOpen,
  setAddDriverModalOpen,
  setAddSectionModalOpen,
  setAddRouteModalOpen,
  setSelectPlanModalOpen,
  setCreateNewTemplateModalOpen,
  setCreateDatedPlanModalOpen,
  setCopyModalOpen,
  setDriversLockedError,
  setDepotLockedError,
  setEditPlanModalOpen,
  setShowReloadPlanManagement,
  setShowReloadDriverManagement,
  setPlanManagementReloadModalOpen,
  setDriverManagementReloadModalOpen,
  setDriverManagementExpiredModalOpen,
  setPlanManagementExpiredModalOpen,
  addNotification,
  removeNotification,
  closeNotification,
  setUnlockDepotModalOpen,
  setUnlockPlanModalOpen,
  setUnlockDriversDayModalOpen,
  setUnlockDriversWeekModalOpen,
  setUnlockMatrixWeekModalOpen,
  setRouteEditOptionsModal,
  setPickupEditOptionsModal,
  setLoading,
  setDeterminateLoading,
  increaseDeterminateLoading,
  resetDeterminateLoading,
  setShowOptimiseAll,
  setSelectedTab,
  setCollectionTimeEdit,
  setMarkerViewType,
  setEditOverridesModalOpen,
  setEditPickupModalOpen,
  resetSelectedPostcodes,
  setSelectSimulatedOverlayOpen,
  setSelectedSimulationPercentage,
  setPostcodeInUseModalContent,
} = ownAppSlice.actions;
export {
  initialState,
  reducer,
  resetAppState,
  setSelectedTimeBand,
  setSelectedRoute,
  setSelectedDriver,
  setSelectedLocation,
  setSelectedSection,
  setSelectedShiftManager,
  setCollectionEditPostcode,
  setEditMapModalOpen,
  setAddArtificialPostcodeModalOpen,
  setAddDriverModalOpen,
  setAddSectionModalOpen,
  setAddRouteModalOpen,
  setSelectPlanModalOpen,
  setCreateNewTemplateModalOpen,
  setCreateDatedPlanModalOpen,
  setCopyModalOpen,
  setDriversLockedError,
  setDepotLockedError,
  setEditPlanModalOpen,
  setShowReloadPlanManagement,
  setShowReloadDriverManagement,
  setPlanManagementReloadModalOpen,
  setDriverManagementReloadModalOpen,
  setDriverManagementExpiredModalOpen,
  setPlanManagementExpiredModalOpen,
  addNotification,
  removeNotification,
  closeNotification,
  setUnlockPlanModalOpen,
  setUnlockDepotModalOpen,
  setUnlockDriversDayModalOpen,
  setUnlockDriversWeekModalOpen,
  setUnlockMatrixWeekModalOpen,
  setRouteEditOptionsModal,
  setPickupEditOptionsModal,
  setLoading,
  setDeterminateLoading,
  increaseDeterminateLoading,
  resetDeterminateLoading,
  setShowOptimiseAll,
  setSelectedTab,
  setCollectionTimeEdit,
  setMarkerViewType,
  setEditOverridesModalOpen,
  setEditPickupModalOpen,
  resetSelectedPostcodes,
  setSelectSimulatedOverlayOpen,
  setSelectedSimulationPercentage,
  setPostcodeInUseModalContent,
};
